import { Chat } from '@mint-sdk/api-ai-assistant';

const isUnsentPrompt = (record: Chat.ChatMessageRecordType) =>
  record.message.type === 'human' &&
  (record.message.isMsgStub || record.message.isApprovingStub);

// Reconciles a fresh REST snapshot with what the cache holds.
export const mergeChatHistory = (
  fresh: Chat.ChatMessageRecordType[],
  cached: Chat.ChatMessageRecordType[] | undefined,
): Chat.ChatMessageRecordType[] => {
  if (!cached?.length) {
    return fresh;
  }

  const freshIds = new Set(fresh.map((record) => record.messageId));
  const newestFreshId = fresh.reduce(
    (max, record) => Math.max(max, record.messageId),
    Number.NEGATIVE_INFINITY,
  );

  const localOnly = cached.filter(
    (record) =>
      !freshIds.has(record.messageId) &&
      (record.messageId > newestFreshId || isUnsentPrompt(record)),
  );

  return localOnly.length ? [...fresh, ...localOnly] : fresh;
};
